/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignInRequest
 */
export interface SignInRequest {
    /**
     * 
     * @type {string}
     * @memberof SignInRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof SignInRequest
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof SignInRequest
     */
    fcm?: string;
    /**
     * 
     * @type {string}
     * @memberof SignInRequest
     */
    deviceType?: string;
}

export function SignInRequestFromJSON(json: any): SignInRequest {
    return SignInRequestFromJSONTyped(json, false);
}

export function SignInRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignInRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'fcm': !exists(json, 'fcm') ? undefined : json['fcm'],
        'deviceType': !exists(json, 'deviceType') ? undefined : json['deviceType'],
    };
}

export function SignInRequestToJSON(value?: SignInRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'password': value.password,
        'fcm': value.fcm,
        'deviceType': value.deviceType,
    };
}


